import type { ThemeConfig } from '../types'
import { trailheadConfig as generated } from '../../generated/theme-presets'

// Trailhead: The canonical DOcurious experience. Like walking into a well-designed nature
// center — warm wood, Cream walls, Scout Green wayfinding, Honey-gold trail markers.
// This is home base. Approachable, encouraging, ready for anything.
export const trailheadConfig: ThemeConfig = generated
